import React, { useEffect, useRef, useState } from 'react';
import styles from './VideoSideToSide.module.css';
import { VideosSideToSideProjectGalleryInterface } from '../../../../../../../lib/types/videosSideToSideProjectGallery';
import { getVideoUrl } from '../../../../../../../lib/sanity.client';

export type VideosProps = {
    videosSTSPG: VideosSideToSideProjectGalleryInterface | null;
};

const VideoSideToSide: React.FC<VideosProps> = ({ videosSTSPG }) => {

    return (
        <>
        {videosSTSPG && 
            <div className={styles.container}>
            {videosSTSPG.videos.map((video, index) => (
                <div className={styles.normal} key={index} >
                    <video
                        key={index}
                        className={styles.video}
                        muted
                        autoPlay={index === 0}                 
                        loop
                        playsInline
                        controls={true}
                    >
                        <source src={getVideoUrl(video) || ''} type="video/mp4" />
                    </video>
                </div>
            ))}
            </div>
        }
        </>
    );
};

export default VideoSideToSide;
